import { render } from "./RolesManager.vue?vue&type=template&id=5c7f80de&scoped=true"
import script from "./RolesManager.vue?vue&type=script&lang=js"
export * from "./RolesManager.vue?vue&type=script&lang=js"

import "./RolesManager.vue?vue&type=style&index=0&id=5c7f80de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7f80de"]])

export default __exports__